<!--title -->
<app-modal-title
  [title]="'pages.campaigns.form.addTitle' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex-center tw-flex-col">
          <!-- title -->
          <form-field
            [(value)]="model.title"
            class="tw-w-[275px]"
            [control]="form?.get('title')"
            label="common.title"
            [maxLength]="64"
          >
          </form-field>

          <!-- save now btn -->
          <button
            type="button"
            (click)="onSaveNow()"
            mat-ripple
            class="btn tw-w-full tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise tw-mt-3"
            [themeColor]="'btn'"
          >
            <span *ngIf="!loading">
              {{ "common.saveNow" | translate }}
            </span>

            <!-- loading -->
            <ng-container *ngIf="loading">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </ng-container>
          </button>

          <!--  Save After Send btn -->
          <button
            type="button"
            (click)="onSaveAfterSend()"
            mat-ripple
            class="btn tw-w-full tw-mt-2 tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise"
            [themeColor]="'btn-info'"
          >
            {{ "common.saveNowAfterSend" | translate }}
          </button>

          <!--  back btn -->
          <button
            type="button"
            (click)="onClose()"
            mat-ripple
            class="btn tw-w-full tw-mt-2 tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise btn-secondary"
          >
            {{ "common.back" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
